module.exports = __webpack_public_path__ + "img/bg_main0606.599e49e4.png";